export default __webpack_public_path__ + "images/WI.c7e2597.png";